export class HTML {
  /**
   * Insert `htmlElement` as first child of `location`
   */
  public static unshift(location: HTMLElement, htmlElement: HTMLElement): void {
    location.insertBefore(htmlElement, location.firstChild);
  }
}
